import { render, staticRenderFns } from "./linked-answer-panel.vue?vue&type=template&id=418e4956&scoped=true"
import script from "./linked-answer-panel.vue?vue&type=script&lang=js"
export * from "./linked-answer-panel.vue?vue&type=script&lang=js"
import style0 from "./linked-answer-panel.vue?vue&type=style&index=0&id=418e4956&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e4956",
  null
  
)

export default component.exports